import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  group: {
    display: 'flex',
    width: '100%',
    padding: 3,
    borderRadius: 999,
    backgroundColor: theme.palette.action.hover
  },
  button: {
    flex: 1,
    height: theme.spacing(3.75),
    minWidth: 0,
    padding: 0,
    border: 'none',
    borderRadius: '999px !important',
    color: theme.palette.text.secondary,
    '& svg': {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25)
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[1]
    }
  }
}));
